import { CommonFilterModel, CommonSortModelResource } from '@/api/resources/common/shared/models/common.models'
import { AgGridCallbackEvent, AgGridCallbackEventType, IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { IServerSideDatasource, IServerSideGetRowsParams } from '@ag-grid-enterprise/all-modules'
import axios from 'axios'

export abstract class BaseDatasource<T> implements IServerSideDatasource {
    protected abstract paginator(
        filterModel: CommonFilterModel,
        sortModel: CommonSortModelResource[],
        page: number,
        size: number
    ): Promise<IResponseAgGrid<T>>

    public async getRows(params: IServerSideGetRowsParams): Promise<void> {
        try {
            const requestStartRow = params.request.startRow ?? 0
            const requestEndRow = params.request.endRow ?? 0
            const size = requestEndRow - requestStartRow
            const page = (requestEndRow / size) - 1

            const paginator = await this.paginator(params.request.filterModel, params.request.sortModel, page, size)
            params.success({ rowData: paginator.content, rowCount: paginator.totalElements })

            params.api.dispatchEvent({
                type: AgGridCallbackEventType.SUCCESS
            } as AgGridCallbackEvent)
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.error(error)
                params.fail()

                params.api.dispatchEvent({
                    type: AgGridCallbackEventType.FAIL,
                    error
                } as AgGridCallbackEvent)
            }
        } finally {
            params.api.dispatchEvent({
                type: AgGridCallbackEventType.END
            } as AgGridCallbackEvent)
        }
    }
}
